import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, inject, input, viewChild } from '@angular/core';
import { ActionSheetService } from './action-sheet.service';
import { ActionSheetOption } from './action-sheet.type';
import { ActionSheetOptionComponent } from './option/action-sheet-option.component';

@Component({
  selector: 'app-action-sheet',
  standalone: true,
  templateUrl: './action-sheet.component.html',
  imports: [CommonModule, ActionSheetOptionComponent],
})
export default class ActionSheetComponent implements AfterViewInit {
  actionSheetRef = viewChild<ElementRef<HTMLElement>>('actionSheet');
  options = input<ActionSheetOption[]>();
  title = input<string>();
  renderItem = input<any>();
  currentValue = input<any>();

  readonly actionSheetService = inject(ActionSheetService);

  ngAfterViewInit(): void {
    this.actionSheetRef()?.nativeElement.animate(
      [
        { opacity: 0, transform: 'translateY(10px)' },
        { opacity: 1, transform: 'translateY(0)' },
      ],
      {
        duration: 200,
        easing: 'ease-in-out',
      },
    );
  }

  handleClick(option: ActionSheetOption) {
    this.actionSheetService.close(option.value);

    if (option.handler) {
      option.handler();
    }
  }

  close() {
    this.actionSheetService.close();
  }
}
